import React, { useState, useEffect } from "react";
import "../../../../../../../styles/shared/approved-payment-list.css";
// components imports
import ApprovedTransectionTable from "../../../../../../../Components/BoltTable/BoltTable";
import InvoiceModal from "../../../../../../../Components/InvoiceModal/InvoiceModal";
import AddBalance from "../AddBalance/AddBalance";

// apis imports
import { fetchShipperTransactions } from "../../../../../../../services/ShipperServices/Payments/payments.services";
import {
  convertTime,
  removeUnderscoresAndCapitalize,
} from "../../../../../../../helpers/helpers";
import { useMoney } from "../../useMoney";
import { useTranslation } from "react-i18next";

// library imports
import { useSelector } from "react-redux";
import { MdAdd, MdOutlineStickyNote2 } from "react-icons/md";
import CircularProgress from "@mui/material/CircularProgress";
import {
  FaArrowAltCircleUp,
  FaArrowAltCircleDown,
} from "react-icons/fa";
import { SiCashapp } from "react-icons/si";
import BoltButton from "../../../../../../../Components/UI/Buttons/BoltButton";

const ApprovedPaymentList = ({ setSnack }) => {
  const { t } = useTranslation("finances");
  const formatMoney = useMoney();
  const user = useSelector((state) => state.user);

  const [transactions, setTransactions] = useState([]);
  const [invoiceLoader, setinvoiceLoader] = useState(false);

  const [invoiceModal, setInvoiceModal] = useState();
  const [addBalanceModal, setAddBalanceModal] = useState();

  const getAllShippersTransactions = async (page, perPage, filter) => {
    const response = await fetchShipperTransactions(page, perPage, filter);
    if (!response.error) {
      setTransactions(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "130px",
    },
    {
      id: 1,
      label: t("columns.transactionId"),
      field_name: "transaction_no",
      render: (row, rowIndex, handleFieldChange) => (
        <>{row?.transaction_no ?? "-"}</>
      ),
      width: "130px",
    },

    {
      id: 3,
      label: t("columns.method"),
      field_name: "method",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row.transaction_type
            ? removeUnderscoresAndCapitalize(row.transaction_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("columns.paymentType"),
      field_name: "payment_type",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row.payment_type
            ? removeUnderscoresAndCapitalize(row.payment_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    // {
    //   id: 5,
    //   label: "Bolt Tracking ID",
    //   field_name: "bolt_tracking_id",
    //   render: (row, rowIndex, handleFieldChange) => (
    //     <>{row.shipment?.tracking_id ?? "-"}</>
    //   ),
    //   width: "200px",
    // },
    {
      id: 6,
      label: t("columns.amount"),
      field_name: "amount",
      render: (row, rowIndex, handleFieldChange) => (
        <div
          style={{
            color: row?.transaction_type?.startsWith("credit")
              ? "teal"
              : "tomato",
            display: "flex",
          }}
        >
          <>
            {formatMoney(row.amount)}
            {row?.transaction_type?.startsWith("credit") ? (
              <FaArrowAltCircleUp
                style={{ marginTop: "2px", marginLeft: "4px" }}
              />
            ) : (
              <FaArrowAltCircleDown
                style={{ marginTop: "2px", marginLeft: "4px" }}
              />
            )}
          </>
        </div>
      ),
      width: "200px",
    },
    {
      id: 7,
      label: t("columns.balance"),
      field_name: "balance",
      render: (row, rowIndex, handleFieldChange) => (
        <>{formatMoney(row.user_balance)}</>
      ),
      width: "200px",
    },
    {
      id: 2,
      label: t("columns.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("columns.invoice"),
      field_name: "invoice",
      render: (row, rowIndex, handleFieldChange) => (
        <div className="table_action__wrap">
          <div
            className={`table_action__btn   ${
              !row.shipment_id &&
              !row.formula_invoice &&
              !row.file &&
              "table_action__btn__disabled"
            }`}
            onClick={() => {
              if (row.shipment_id) {
                setInvoiceModal(row.shipment_id);
              } else {
                if (row.formula_invoice?.file) {
                  downloadPdf(row.id, row?.formula_invoice?.file);
                } else {
                  downloadPdf(row.id, row?.file);
                }
              }
            }}
          >
            {invoiceLoader === row.id ? (
              <CircularProgress size={10} />
            ) : (
              <MdOutlineStickyNote2 size={10} />
            )}
            {t("transactions.invoiceButton")}
          </div>
        </div>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("columns.description"),
      field_name: "description",
      render: (row, rowIndex, handleFieldChange) => (
        <>{row.description ?? "-"}</>
      ),
      width: "200px",
    },
  ];

  const downloadPdf = async (id, urlfull) => {
    setinvoiceLoader(id);
    const urlParts = urlfull.split("/");
    const filename = urlParts[urlParts.length - 1];
    try {
      fetch(urlfull, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setinvoiceLoader(false);
        });
    } catch (error) {
      setinvoiceLoader(false);
    }
  };

  return (
    <div
      className="dispatcher__screen"
      style={{ maxWidth: "100%", padding: "0px 5px" }}
    >
      <InvoiceModal
        open={!!invoiceModal}
        data={invoiceModal}
        setOpen={setInvoiceModal}
        actions={false}
      />
      <AddBalance
        open={addBalanceModal}
        setOpen={setAddBalanceModal}
        setSnack={setSnack}
        getAllTransactions={() => getAllShippersTransactions(1, 20, "")}
      />
       <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ApprovedTransectionTable
          tableTitle={t("transactions.title")}
          tableId="approvedTransactionTableForShipper"
          message={t("transactions.emptyApproved")}
          searchPlaceHolder={t("transactions.search")}
          getAllData={getAllShippersTransactions}
          data={transactions}
          columns={columns}
          headerButtons={
            <div className="flex gap-1.5 flex-wrap">
              <div
                className={`
                  flex items-center justify-center gap-2
                  px-2 min-h-[30px] min-w-fit
                  rounded-lg border shadow-sm
                  bg-ui-surface-sunken
                `}
              >
                <SiCashapp className="w-4 h-4 text-ui-text" />

                <span
                  className="
                    font-medium
                    text-[11px]
                    3xl:text-xs
                    4xl:text-sm
                    text-ui-text
                  "
                >
                  {t("transactions.availableBalance")}
                  <b> {formatMoney(user.balance)}</b>
                </span>
              </div>
              <BoltButton
                icon={MdAdd}
                label={t("transactions.addBalance")}
                onClick={() => setAddBalanceModal(true)}
                variant="primary"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ApprovedPaymentList;
